import SanitizedGrid from "../../../components/SanitizedGrid";
import { Grid } from "@material-ui/core";
import CustomAddressAutoCompleteInput from "./CustomAddressAutoCompleteInput";
import { FormDataConsumer, required, SimpleForm, TextInput } from "react-admin";
import CalculationAreaButton from "./CalculationAreaButton";
import React, { useState } from "react";
import { meterToKilometer } from "utils/tools";

const CalculateAreaInput = () => {
  const [resultCalculations, setResultCalculations] = useState<any>();

  return (
    <SimpleForm toolbar={null}>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={4}>
          <CustomAddressAutoCompleteInput
            label="Postal Code"
            source="billingAddress.postalCode"
            referenceSource="locationData"
          />
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={2}>
          <TextInput label="Unit No." source="billingAddress.unit" />
        </Grid>
        <Grid item xs={2}>
          <TextInput label="Block No." source="billingAddress.blockNumber" />
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={4}>
          <TextInput label="Building Name" source="billingAddress.building" />
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={4}>
          <TextInput
            label="Address"
            source="billingAddress.address"
            validate={required()}
          />
        </Grid>
        <Grid item xs={8}></Grid>

        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <Grid item xs={12}>
              <CalculationAreaButton
                formData={formData}
                setResultCalculations={setResultCalculations}
              />
            </Grid>
          )}
        </FormDataConsumer>

        <Grid item xs={12}></Grid>
        {resultCalculations ? (
          <>
            <Grid item xs={4}>
              <div style={{ fontSize: "18px", fontWeight: "bold" }}>Result</div>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <div>{`Area Name : ${resultCalculations.name}`}</div>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <div>
                {`Actual Distance in Meter : ${
                  resultCalculations.actualDistanceInMeters
                } m (${meterToKilometer(
                  resultCalculations.actualDistanceInMeters
                )} km)`}
              </div>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <div>
                {`Max Distance in Meter : ${
                  resultCalculations.maxDistanceInMeters
                } m (${meterToKilometer(
                  resultCalculations.maxDistanceInMeters
                )} km)`}
              </div>
            </Grid>
            <Grid item xs={8}></Grid>
          </>
        ) : null}
      </SanitizedGrid>
    </SimpleForm>
  );
};

export default CalculateAreaInput;
